module.exports = __webpack_public_path__ + "store/img/shop-tags-personalize-qr.224c8571.png";